import styled from 'styled-components';

export default styled.h2`
  color: ${(props) => props.theme.colors.darken};
  font-family: Gotham Pro;
  font-size: 18px;
  line-height: 26px;
  padding-bottom: 8px;
`;
